export function cleanGraphIds(ids?: Array<string | null | undefined> | null): string[] {
  const out: string[] = [];
  const seen = new Set<string>();

  for (const raw of ids ?? []) {
    const id = String(raw ?? '').trim();
    if (!id || seen.has(id)) continue;
    seen.add(id);
    out.push(id);
  }

  return out;
}

export function cleanParentIds(ids?: Array<string | null | undefined> | null): string[] {
  return cleanGraphIds(ids);
}
